import { createFileRoute } from "@tanstack/react-router";
import Page from "lib/components/layout/Page";
import { locationPublicMapPath, useAppRouterParams } from "lib/routeHelpers";
import styles from "./index.module.scss";

/**
 * Debug page that embeds the community sales map in an iframe,
 * simulating how it appears on a builder's website.
 */
function SalesMapEmbed() {
  const { builderId, locationId } = useAppRouterParams();

  if (!builderId || !locationId) {
    return null;
  }

  const mapUrl = locationPublicMapPath(builderId, locationId);

  return (
    <Page pageTitle="Embedded Sales Map">
      <div className={styles.widgets}>
        <p>Community sales map embedded in an iframe (scroll zoom disabled until first click).</p>
        <iframe
          src={mapUrl}
          title="Community Sales Map"
          style={{ width: "100%", height: "80vh", border: "1px solid #ccc" }}
        />
      </div>
    </Page>
  );
}

export const Route = createFileRoute("/debug/builder-website/sales-map")({
  component: SalesMapEmbed,
});
